import React from "react";
import "./header.css";

const Header = () => (
    <header>
        <h1 className="main-heading">Lykke with Weather 🏖</h1>
    </header>
);

export default Header;